import React from 'react';
import { motion } from 'framer-motion';
import { FaChartLine } from 'react-icons/fa';

interface AboutProjectManagementSectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  contentAr?: string;
  contentEn?: string;
}

const AboutProjectManagementSection: React.FC<AboutProjectManagementSectionProps> = ({
  language = 'ar',
  titleAr = "إدارة المشاريع",
  titleEn = "Project Management",
  contentAr = "ننجح في إدارة المشاريع عبر التركيز على عناصر الوقت، الجودة، والتكلفة، واستخدام حلول إدارية وتقنية حديثة تضمن تنفيذ المشاريع بكفاءة واحترافية.",
  contentEn = "We succeed in project management by focusing on the elements of time, quality, and cost, using modern administrative and technical solutions that ensure efficient and professional project execution."
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mr-4">
                <FaChartLine className="w-6 h-6 text-white" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">{isRTL ? titleAr : titleEn}</h2>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              {isRTL ? contentAr : contentEn}
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex justify-center"
          >
            {/* Project Management Triangle */}
            <div className="relative w-64 h-64">
              <svg viewBox="0 0 200 200" className="w-full h-full">
                {/* Outer Triangle */}
                <polygon
                  points="100,20 180,160 20,160"
                  fill="none"
                  stroke="#3B82F6"
                  strokeWidth="3"
                  className="animate-pulse"
                />
                {/* Cost Side */}
                <polygon
                  points="100,20 180,160 140,160 100,60"
                  fill="#F97316"
                  opacity="0.8"
                />
                {/* Time Side */}
                <polygon
                  points="100,20 20,160 60,160 100,60"
                  fill="#6B7280"
                  opacity="0.8"
                />
                {/* Quality Side */}
                <polygon
                  points="20,160 180,160 140,160 60,160"
                  fill="#10B981"
                  opacity="0.8"
                />
                {/* Inner Triangle (Scope) */}
                <polygon
                  points="100,80 140,140 60,140"
                  fill="#EF4444"
                  opacity="0.9"
                />
                
                {/* Labels */}
                <text x="140" y="90" className="text-xs font-bold fill-white" transform="rotate(30 140 90)">COST</text>
                <text x="60" y="90" className="text-xs font-bold fill-white" transform="rotate(-30 60 90)">TIME</text>
                <text x="100" y="170" className="text-xs font-bold fill-white">QUALITY</text>
                <text x="100" y="120" className="text-xs font-bold fill-white">SCOPE</text>
              </svg>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutProjectManagementSection; 